import { theme } from '@weave/theme';
import { Text } from '@weave/design-system';
import { css, SerializedStyles } from '@emotion/core';

type InfoCardProps = {
  title: string;
  children: React.ReactNode;
  style?: SerializedStyles;
};

export const InfoCard = ({ title, children, style }: InfoCardProps) => {
  return (
    <section css={[InfoCardStyles, style]}>
      <Text size="large" color="subdued" weight="bold">
        {title}
      </Text>
      {children}
    </section>
  );
};

const InfoCardStyles = css({
  borderRadius: theme.borderRadius.medium,
  border: `1px solid ${theme.colors.neutral50}`,
  minWidth: '200px',
  padding: theme.spacing(2),
});
